(function(){
  if (window.ccHomeInit) return; window.ccHomeInit = true;
  function run(root){
    var els = (root || document).querySelectorAll('.cch .reveal:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: .12 });
    els.forEach(function(e){ io.observe(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ run(); }); else run();
  document.addEventListener('shopify:section:load', function(e){ run(e.target); });
})();
